<i18n>
{
  "en": {
    "label": {
    },
    "message": {
      "header": "Since you are currently reviewing data, you can only change comments and add files. Please note that if you change the comment, the previous comment will be deleted. It is impossible to delete already submitted files.",
      "uploading": "Now uploading...",
      "hires": "Please submit <b>\"High Resolution Image Data\" (JPEG or TIFF data with the highest quality) without credit</b> for the winning candidate.",
      "hiresOption": "Please submit an image that has been cropped in the same way as the work posted on SNS.",
      "original": "Please submit <b>\"RAW data\" of the winning candidate work or “original data before processing (the highest quality of JPEG data or TIFF data, with EXIF information left).</b>",
      "originalOption": "It is for the purpose of identity verification to prevent plagiarism. Thank you for your cooperation."
    },
    "alert": {
      "confirmUpdateComment": "Will update the comment with the content described. Is it OK?",
      "doneUpdate": "Update completed",
      "donePost": "Submission completed",
      "uploadError": "Could not send correctly. Please try again later or contact us if you experience repeated errors."
    }
  },
  "ja": {
    "label": {
    },
    "message": {
      "header": "現在データを確認中のため、コメントの変更とファイルの追加のみ可能です。コメントの変更を行った場合、前回のコメントは削除されますので、ご注意ください。既に提出済みのファイルの削除は不可能です。",
      "uploading": "アップロード中…",
      "hires": "<b>受賞候補作品のクレジットなしの「高解像度画像データ」（JPEGもしくはTIFFデータで最高画質のもの）</b>をご提出下さい。",
      "hiresOption": "※SNS投稿作品が受賞候補となっている場合は、投稿時と同じようにトリミングしていただいた画像のご提出をお願いします。",
      "original": "<b>受賞候補作品の「RAWデータ」もしくは「Exif（撮影日時や撮影機種）が保存されている、加工前のオリジナルデータ（カメラで撮ったままの、何のソフトウェアも使用していない画像データ）」</b>をご提出下さい。",
      "originalOption": "盗作防止のためにご本人様確認を行う目的でお願いしております。恐れ入りますがご協力をお願い申し上げます。"
    },
    "alert": {
      "confirmUpdateComment": "記載の内容でコメントを更新します。よろしいですか？",
      "doneUpdate": "更新が完了しました",
      "donePost": "送信が完了しました",
      "uploadError": "正しく送信できませんでした。時間を置いてお試しいただくか、繰り返しエラーが発生する場合はお問い合わせをお願いいたします。"
    }
  }
}
</i18n>

<template>
  <div class="upload-form-wrapper">
    <v-container>
      <v-layout wrap style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <v-alert
          outline
          :value="true"
          color="success"
          icon="info"
          class="text-sm-left mb-3"
          style=" max-width: 640px;"
        >
          {{ this.$t('message.header') }}
        </v-alert>
      </v-layout>

      <v-layout wrap style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          v-if="mySubmission.submissionType === EnumSubmissionType.HiRes"
          style="width: 100%; max-width: 640px; text-align: left;"
        >
          <span style="color: red" class="subheading" v-html="$t('message.hires')"></span>
          <a :href="'/cp/' + getCampaignCode() + '/me/help#category3'" target="_blank" style="text-decoration: none;"><v-icon class="ml-1 hover-icon" slot="activator" dark color="primary">help_outline</v-icon></a>
          <br />
          <br />
          <p class="red--text">{{ $t('message.hiresOption') }}</p>
        </v-flex>
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          v-if="mySubmission.submissionType === EnumSubmissionType.Original"
          style="width: 100%; max-width: 640px; text-align: left;"
        >
          <span style="color: red" class="subheading" v-html="$t('message.original')"></span>
          <a :href="'/cp/' + getCampaignCode() + '/me/help#category2'" target="_blank" style="text-decoration: none;"><v-icon class="ml-1 hover-icon" slot="activator" dark color="primary">help_outline</v-icon></a>
        </v-flex>
        <v-flex style="width: 100%; max-width: 640px;">
          <FileDrop
            :uploadFunc="postFiles"
            :subOption="fileTypeOptions"
            :mustAnsToSubOption="true"
            :isVisibleUserComment="false"
            :submissionType="mySubmission.submissionType"
          ></FileDrop>
        </v-flex>
      </v-layout>
    </v-container>

    <LoadingDialog
      :isLoading="isLoading"
      :loadingMessage="this.$t('message.uploading')"
    />
  </div>
</template>

<script>
import FileDrop from '@/components/atoms/FileDrop.vue';
import TextInput from '@/components/atoms/TextInput.vue';
import LoadingDialog from '@/components/dialogs/LoadingDialog.vue';
import { Me } from '@/api';
import subOptionHandler from '@/helper/subOptionHandler.js';
import { EnumSubmissionType } from '@/enum/enum.js';
import StorageManager from '@/utils/StorageManager';

export default {
  components: {
    FileDrop,
    TextInput,
    LoadingDialog
  },
  props: {
    submission: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      mySubmission: {},
      EnumSubmissionType: EnumSubmissionType,
      isLoading: false
    };
  },
  watch: {
    submission: function(newVal) {
      this.mySubmission = Object.assign({}, newVal);
    }
  },
  methods: {
    /**
     * EnumのTypeとCodeとlocaleからEnumの文字列を返却
     * @param String type EnumのType
     * @param Integer code EnumのCode
     */
    getEnumStr(type, code) {
      return this.$store.getters.getEnumByCode({ type, code });
    },
    reload() {
      this.$router.go();
    },
    postFiles(files) {
      return new Promise((resolve, reject) => {
        this.isLoading = true;

        this.uploadFiles(files)
          .then(files => {
            return Me.addFilesToSubmission(this.mySubmission.id, files);
          })
          .then(() => {
            alert(this.$t('alert.donePost'));
            this.reload();
            resolve();
          })
          .catch(error => {
            alert(this.$t('alert.uploadError'));
            reject(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    async uploadFiles(files) {
      let fileList = [];
      for (const file of files) {
        await Me.uploadFile(file.dataAsForm).then(uuid => {
          fileList.push({
            submissionFileType: file.subOptionAnswer.code,
            tmpFileUuid: uuid
          });
        });
      }
      return fileList;
    },
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    }
  },
  computed: {
    fileTypeOptions() {
      let list = this.$store.getters.getEnumsObjByType('submissionFileType');
      return subOptionHandler(list, this.mySubmission.submissionType);
    }
  }
};
</script>

<style lang="stylus" scoped>
.upload-form-wrapper
    background-color: white;
    padding: 10px;
    width: 100%;
    min-height: 300px;
    height: 50%;
    text-align: center;
</style>
